import React from "react";
import TagManager from 'react-gtm-module';
import {
  Switch,
  Route,
  Redirect,
  Link as RouterLink,
  useHistory,
  useLocation,
} from "react-router-dom";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import ServiceWorkerWrapper from "./components/serviceworkerwrapper.component";
import { ToastContainer, Slide } from "react-toastify";
import Spinner from "./components/spinner/spinner.component";
import { logoutUser, sendAppLink, loginFromWeb } from "./store/actions/authActionCreators";
import { makeStyles,withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import Container from "@material-ui/core/Container";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import MUISlide from "@material-ui/core/Slide";
import { trackEvent } from "./analytics";
import queryString from "query-string";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import { toast } from "react-toastify";
import { LedgerIcon, LedgerIconUnSelected,PremiumPageIcon} from "./components/icons"
import './fonts/index.css';
import * as logger from './logger';
import PinDropIcon from '@material-ui/icons/PinDrop';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
const tagManagerArgs = {
  gtmId: 'GTM-KKQG858'
}
export const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
export const CustomDialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f1f3f6"
  },
  "@global": {
    scrollBehavior: 'smooth',
    "*::-webkit-scrollbar": {
      width: "0.4em",
    },
    "*::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "*::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,.1)",
      outline: "1px solid slategrey",
    },
  },
  selected: {
    color: "#00875a !important",
  },
  unselected: {
    color: "#9da1a7 !important"
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    fontSize: 13,
    fontWeight: 800,
  },
  text: {
    padding: theme.spacing(2, 2, 0),
  },
  paper: {
    paddingBottom: 50,
  },
  list: {
    marginBottom: theme.spacing(2),
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
  appBar: {
    top: "auto",
    bottom: 0,
    right: "auto",
    zIndex: 999,
    [theme.breakpoints.up("lg")]: {
      maxWidth: 480,
      borderLeft: "1px solid #c5c7ca",
      borderRight: "1px solid #c5c7ca",
    },
    [theme.breakpoints.up("xl")]: {
      maxWidth: 480,
      borderLeft: "1px solid #c5c7ca",
      borderRight: " 1px solid #c5c7ca",
    },
  },
  shareAppPowered: {
    fontSize: 13,
    color: "#0b1323",
    marginBottom: 5,
    marginTop: 5,
  },
  gotoButton: {
    paddingTop: 15,
    paddingBottom: 15,
    margin: 5,
    backgroundColor: "#00875a",
    "&:hover": {
      backgroundColor: " #00875a",
    },
  },
  sendSMS: {
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#00875a",
    "&:hover": {
      backgroundColor: " #00875a",
    },
  },
  shareAppBar: {
    top: "auto",
    bottom: 0,
    right: "auto",
    backgroundColor: "#FFF",
    zIndex: 999,
    textAlign: "center",
    [theme.breakpoints.up("lg")]: {
      maxWidth: 480,
      borderLeft: "1px solid #c5c7ca",
      borderRight: "1px solid #c5c7ca",
    },
    [theme.breakpoints.up("xl")]: {
      maxWidth: 480,
      borderLeft: "1px solid #c5c7ca",
      borderRight: " 1px solid #c5c7ca",
    },
  },
  grow: {
    flexGrow: 1,
  },
  addTripIcon: {
    marginRight: theme.spacing(1),
  },
  fabMargin: {
    position: "absolute",
    zIndex: 1,
    top: -60,
    left: 0,
    right: 0,
    margin: "0 auto",
  },
  fabButton: {
    position: "absolute",
    zIndex: 1,
    top: -60,
    left: 0,
    right: 0,
    margin: "0 auto",
    width: 150,
    backgroundColor: " #34875a",
    paddingTop: 10,
    paddingBottom: 10,
    color: "#fff",
    fontWeight: 600,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: " #34875a",
    },
  },
  container: {
    scrollBehavior: 'smooth',
    padding: 0,
    backgroundColor: "#fff",
    height: "100vh",
    overflow: "auto",
    [theme.breakpoints.up("lg")]: {
      maxWidth: 480,
      borderLeft: "1px solid #c5c7ca",
      borderRight: "1px solid #c5c7ca",
      backgroundColor: "#f1f3f6",
      visibility:'hidden'
    },
    [theme.breakpoints.up("xl")]: {
      maxWidth: 480,
      borderLeft: "1px solid #c5c7ca",
      borderRight: " 1px solid #c5c7ca",
      backgroundColor: "#f1f3f6",
      visibility:'hidden'
    },
  },
  deskTopContainer: {
    scrollBehavior: 'smooth',
    padding: 0,
    height: "100vh",
    overflow: "auto",
    width:'100%',
    maxWidth:'100%',
    [theme.breakpoints.between("xs","sm")]: {
      visibility:'hidden'
    },
    [theme.breakpoints.between("sm",'md')]: {
      visibility:'hidden'
    },
  },
  logo: {
    borderRadius: 3,
    backgroundColor: "#fff",
  },
  profileCard: {
    margin: 10,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  pos: {
    marginBottom: 12,
    fontSize: 13,
  },
  userName: {
    fontSize: 14,
    paddingBottom: 10,
  },
  logOut: {
    fontSize: 14,
    fontWeight: 700,
  },
  profileListItem: {
    padding: "12px 0",
  },
  profileListItemLogOut: {
    padding: "12px 0",
    paddingBottom: 0,
  },
  listPrimaryText: {
    fontWeight: 300,
    marginBottom: 5,
  },
  listPrimaryText1: {
    fontWeight: 700,
  },
  paperExportData: {
    width: "80%",
    maxHeight: 435,
  },
  infoIcon: {
    color: "#00875a",
  },
  bottomNav: {
    width: "100%",
    color: "#9da1a7"
  },
  navColor: {
    color: "#9da1a7"
  },
  toolbar: {
    backgroundColor: "#fff",
  },
  appModalBar: {
    position: "relative",
  },
  back: {
    color: "#8b8b8e",
  },
  tripViewTitle: {
    color: "#0b1323",
    fontSize: 16,
  },
  youtube: {
    color: "#d71e1d",
  },
  dialogStyle: {
    top: "75% !important",
  },
  playStoreDialogStyle: {
    top: "5% !important",
    bottom:"8px !important",
  },
  dialogPaperStyle: {
    borderTopLeftRadius: "30px",
    borderTopRightRadius: "30px",
  },
  dialogPlayStorePaperStyle: {
    borderRadius:" 16px",
    margin:8
    //borderTopLeftRadius: "30px",
    //borderTopRightRadius: "30px",
  },
  modalResponsive: {
    [theme.breakpoints.up("lg")]: {
      //left: "30% !important",
      //right: "30% !important",
      maxWidth: 480,
      margin: "0 auto"
    },
    [theme.breakpoints.up("xl")]: {
      //left: "30% !important",
      //right: "30% !important",
      maxWidth: 480,
      margin: "0 auto"
    },
  },
  startIcon: {
    color: 'white',
    fontWeight: 600,
    marginLeft: -20,
    marginRight: 15,
    '& > svg': {
      fontSize: "22px !important",
    }
  },
  pinDropIcon: {
    width: '1.3em',
    height: '1.05em !important'
  },
  playInfo:{
    fontSize:18,
    color:"#697077",
    textAlign:'center',
    marginBottom:32
  },
  transportBook:{
    fontWeight: 600,
    color:" #0b1323",
  },
  playInfoIcon:{
    textAlign:'center',
    marginBottom:0
  },
  playIcon:{
    fontSize:214,
    textAlign:'center'
  },
  appFeatureLi:{
    fontWeight:600,
    color:"#0b1323"
  },
  liBullet:{
    marginRight:8,
    fontSize:10,
    color:'#adb6c0'
  },
  appImg:{
    width:'100%'
  },
  downloadApp:{
    fontWeight:600,
    fontSize:17
  },
  playStoreContent:{
    textAlign:'center',
    marginBottom:0
  },
  downloadAppBtn:{
    fontWeight:600,
    paddingTop: 8,
    paddingBottom: 8,
    textAlign:'center',
    backgroundColor: "#fff",
    boxShadow:'none',
    "&:hover": {
      backgroundColor: " #fff",
      boxShadow:'none',
    }
  },
  downloadPlayBtn:{
    width:202
  }
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <MUISlide direction="up" ref={ref} {...props} />;
});
const App = ({ user, dispatchLogoutAction, dispatchSendAppLink, dispatchLoginFromWeb }) => {
  let search = window.location.search;
  const values = queryString.parse(search);
  let mode = values["mode"];
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  //const [authRedirect, setAuthRedirect] = React.useState(true);
  const [createTripOpen, setCreateTripOpen] = React.useState(false);
  const [sendAppLinkOpen, setSendAppLinkOpen] = React.useState(false);
  const [redirectToPlayStore, setRedirectToPlayStore] = React.useState(true);
  const [exportDataModalOpen, setExportDataModalOpen] = React.useState(false);
  const [
    partyExportDataModalOpen,
    setPartyExportDataModalOpen,
  ] = React.useState(false);
  const [
    vendorExportDataModalOpen,
    setVendorExportDataModalOpen,
  ] = React.useState(false);
  const [sendSMSNumber, setSendSMSNumber] = React.useState("");
  const [sendSMSAppLinkError, setSendSMSAppLinkError] = React.useState(false);
  const [exportData, setExportData] = React.useState(null);
  React.useEffect(() => {
    TagManager.initialize(tagManagerArgs)
  }, []);
  const [path, setPath] = React.useState([
    "/user-profile",
    "/party-ledger",
    "/all-trucks",
    "/trip-ledger"
  ]);
  let location = useLocation();
  let history = useHistory();
  const handleAddTripClick = () => {
    trackEvent("Trip Create Initiated", {
      mode: null,
    });
    setCreateTripOpen(true);
  };
  const handleCreateTripClose = () => {
    setCreateTripOpen(false);
  };
  const handleSendSMSClose = () => {
    setSendAppLinkOpen(!sendAppLinkOpen);
  };
  const handlePlayStoreClose = () => {
    setRedirectToPlayStore(!redirectToPlayStore);
  };
  const handleSendSMSOpen = () => {
    setSendAppLinkOpen(!sendAppLinkOpen);
  };
  const handleExportDataDialogClose = (newValue) => {
    setExportDataModalOpen(false);
    if (newValue) {
      setExportData(newValue);
      setPartyExportDataModalOpen(true);
    }
  };
  const handlePartyExportDataDialogClose = (newValue) => {
    setPartyExportDataModalOpen(false);
  };
  const handleVendorExportDataDialogClose = (newValue) => {
    setVendorExportDataModalOpen(false);
  };
  const handleVendorExportDataDialogOpen = (newValue) => {
    setVendorExportDataModalOpen(true);
  };
  const sendAppLinkToUser = () => {
    if (sendSMSNumber && sendSMSNumber.length == 10) {
      dispatchSendAppLink(
        sendSMSNumber,
        () => {
          handleSendSMSClose(true);
          toast.success("SMS Sent Successful");
        },
        (message) => toast.error(`Error: ${message}`)
      );
    } else {
      setSendSMSAppLinkError(true);
    }
  };
  const exportDataAll = () => {
    setExportData(null);
    setExportDataModalOpen(true);
  };
  let homeSubPath = ["/auth"];
  let tripSharePath = ["/tripshare"];
  let vendorTripSharePath = ["/vendortripshare"];
  const handleBottomNavigationClick = (event, value) => {
    setValue(value);
  };
  const bull = <span className={classes.bullet}>•</span>;
  let authRedirect = true;
  if (location.pathname.indexOf(tripSharePath) != -1) {
    authRedirect = !authRedirect;
  } else if (location.pathname.indexOf(vendorTripSharePath) != -1) {
    authRedirect = !authRedirect;
  }
  else if (location.pathname.indexOf(homeSubPath) != -1) {
    logger.log("App.js", "the Values", values)
    if (values && values.web && !user.loginFromWeb) {
      let splitted = values.web.split('tpbook');
      if (splitted[0]) {
        localStorage.setItem("USER_FROM_WEB", splitted[0]);
      }
      if (splitted[1]) {
        localStorage.setItem("USER_FROM_WEB_ID", splitted[1]);
      }
      dispatchLoginFromWeb({}, (data) => {
        localStorage.removeItem("USER_FROM_WEB");
        localStorage.removeItem("USER_FROM_WEB_ID");
      }, () => {
        history.push('/auth')
        dispatchLogoutAction();
      });
    }
  }
  const BottomNav = (
    <>
      <BottomNavigation
        value={value}
        onChange={(event, newValue) =>
          handleBottomNavigationClick(event, newValue)
        }
        showLabels
        className={classes.bottomNav}
      >
        <BottomNavigationAction
          label="Ledger"
          icon={(location.pathname.indexOf(path[1]) != -1) ? <LedgerIcon /> : <LedgerIconUnSelected />}
          component={RouterLink}
          to={path[1]}
          className={classes.navColor}
          classes={{ selected: (location.pathname.indexOf(path[1]) != -1) ? classes.selected : classes.unselected, root: (location.pathname.indexOf(path[1]) != -1) ? classes.selected : classes.unselected }}
        />
        <BottomNavigationAction
          label="Trips"
          icon={<PinDropIcon className={classes.pinDropIcon} />}
          component={RouterLink}
          to={path[3]}
          className={classes.navColor}
          classes={{ selected: (location.pathname.indexOf(path[3]) != -1) ? classes.selected : classes.unselected, root: (location.pathname.indexOf(path[3]) != -1) ? classes.selected : classes.unselected }}
        />
        <BottomNavigationAction
          label="Trucks"
          icon={<LocalShippingIcon />}
          component={RouterLink}
          to={path[2]}
          className={classes.navColor}
          classes={{ selected: (location.pathname.indexOf(path[2]) != -1) ? classes.selected : classes.unselected, root: (location.pathname.indexOf(path[2]) != -1) ? classes.selected : classes.unselected }}
        />
        <BottomNavigationAction
          label="Profile"
          icon={<AccountCircleIcon />}
          component={RouterLink}
          to={path[0]}
          className={classes.navColor}
          classes={{ selected: (location.pathname.indexOf(path[0]) != -1) ? classes.selected : classes.unselected, root: (location.pathname.indexOf(path[0]) != -1) ? classes.selected : classes.unselected }}
        />
      </BottomNavigation>
    </>
  );
  return (
    <>
      <ServiceWorkerWrapper />
      <Spinner />
      <Container component="main" className={classes.container}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          transition={Slide}
        />
        <div className={classes.root}>
          <Dialog
            fullScreen
            className={classes.modalResponsive}
            disableEscapeKeyDown={true}
            disableBackdropClick={true}
            open={sendAppLinkOpen}
            onClose={handleSendSMSClose}
            TransitionComponent={Transition}
            classes={{
              root: classes.dialogStyle,
              paper: classes.dialogPaperStyle,
            }}
            aria-labelledby="customized-dialog-title"
          >
            <CustomDialogTitle
              id="customized-dialog-title"
              onClose={handleSendSMSClose}
            >
              App Link
            </CustomDialogTitle>
            <DialogContent dividers>
              <FormControl fullWidth variant="outlined" autoFocus>
                <InputLabel htmlFor="sendSMSAppLink">Mobile Number</InputLabel>
                <OutlinedInput
                  id="sendSMSAppLink"
                  onChange={(e) => {
                    setSendSMSNumber(e.target.value);
                    if (e.target.value > 0) {
                      setSendSMSAppLinkError(false);
                    }
                  }}
                  inputProps={{ type: "number" }}
                  placeholder="Mobile Number"
                  value={sendSMSNumber}
                  startAdornment={
                    <InputAdornment position="start">+91</InputAdornment>
                  }
                  label="Mobile Number"
                  error={sendSMSAppLinkError}
                />
                <FormHelperText
                  id="sendSMSAppLinkError"
                  error={sendSMSAppLinkError ? "error" : ""}
                >
                  {sendSMSAppLinkError ? "Enter Mobile Number Correctly" : ""}
                </FormHelperText>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                className={classes.sendSMS}
                onClick={sendAppLinkToUser}
                fullWidth={true}
              >
                Send SMS
              </Button>
            </DialogActions>
          </Dialog>
          {redirectToPlayStore && <Dialog
            fullScreen
            className={classes.modalResponsive}
            disableEscapeKeyDown={true}
            disableBackdropClick={true}
            open={redirectToPlayStore}
            onClose={handlePlayStoreClose}
            TransitionComponent={Transition}
            classes={{
              //root: classes.playStoreDialogStyle,
              //paper: classes.dialogPlayStorePaperStyle,
            }}
            aria-labelledby="customized-dialog-title"
          >
            <CustomDialogTitle
              id="customized-dialog-title"
              //onClose={handlePlayStoreClose}
            >
              <span className={classes.downloadApp}>Use our App for Better Experience</span>
            </CustomDialogTitle>
            <DialogContent>
              <p className={classes.playInfoIcon}><PremiumPageIcon className={classes.playIcon} /></p>
              <p className={classes.playInfo}>"Download <span className={classes.transportBook} >TransportBook</span> from Playstore"</p>
              <p className={classes.appFeatureLi}><FiberManualRecordIcon className={classes.liBullet} />Get monthly bill and share it to parties</p>
              <p className={classes.appFeatureLi}><FiberManualRecordIcon className={classes.liBullet}/>Get Profit Report and Party Bill in 1 click</p>
              <p className={classes.playStoreContent}>
                <Button
                  variant="contained"
                  className={classes.downloadAppBtn}
                  href="https://tpbook.app.link/KsQePfrwD3"
                >
                  <img className={classes.downloadPlayBtn} src={`${process.env.PUBLIC_URL}/assets/images/google-play-badge.png`} alt={"Play Store"} />
                </Button>
              </p> 
            </DialogContent>
            {/* <DialogActions>
              <Button
                variant="contained"
                color="primary"
                className={classes.downloadAppBtn}
                href="https://tpbook.app.link/KsQePfrwD3"
                fullWidth={true}
              >
                Download App
              </Button>
              <img src={`${process.env.PUBLIC_URL}/assets/images/google-play-badge.png`} alt={"Transport Footer"} />
            </DialogActions> */}
          </Dialog>}
        </div>
      </Container>
    </>
  );
};
const mapStateToProps = (state) => ({ user: state.user });
const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutAction: () => dispatch(logoutUser()),
  dispatchSendAppLink: (mobileNumber, onSuccess, onError) => dispatch(sendAppLink({ mobileNumber }, onSuccess, onError)),
  dispatchLoginFromWeb: (data, onSuccess, onError) => dispatch(loginFromWeb(data, onSuccess, onError)),
});
export default connect(mapStateToProps, mapDispatchToProps)(App);
